import { render, staticRenderFns } from "./zuowenplan.vue?vue&type=template&id=4a75d21c&scoped=true&"
import script from "./zuowenplan.vue?vue&type=script&lang=js&"
export * from "./zuowenplan.vue?vue&type=script&lang=js&"
import style0 from "./zuowenplan.vue?vue&type=style&index=0&id=4a75d21c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a75d21c",
  null
  
)

export default component.exports